import React from "react";
import API from "@unisearch/helpers/api";
import ConsultantsInchandigarh from "@modules/consultants/consultants_In_chandigarh";
import { getAssets } from "@unisearch/helpers";
import { LayoutMain } from "@unisearch/theme/layout";

const ConsultantsInBangalorePage = ({ pageData }) => {
  return (
    <LayoutMain
      contactInfo={{
        phone: "017-24118996",
        email: "info.chandigarh@myunisearch.com",
      }}
      title="Study Abroad Consultants in Chandigarh"
      metaTitle="Study Abroad Consultants in Chandigarh"
      metaImage={getAssets(
        "assets/images/consultant/unisearch-chandigarh-meta.png"
      )}
      metaDescription="Are you hoping to study abroad but not sure where to begin? UniSearch - the best study abroad consultants in Chandigarh - are here to help. At UniSearch, our goal is simple - making the right study abroad solutions accessible to every student, every step of the way. UniSearch Chandigarh’s study abroad consultants bring over 20 years of experience to the table, with thousands of successful university and student visa applications under their belts. They understand how to profile-match you to your ideal programs and universities in six major destinations: the USA, UK, Australia, Canada, Ireland, and New Zealand. Be it in person at our Chandigarh branch or remotely through our virtual office, these overseas education specialists go above and beyond to make your study abroad dreams come true."
      metaKeywords="study abroad, UniSearch, education, consultants, Chandigarh’s study, virtual office, overseas, visa counselling, language test training"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/study-abroad-consultants-in-chandigarh`}
    >
      <ConsultantsInchandigarh pageData={pageData} />
    </LayoutMain>
  );
};

export default ConsultantsInBangalorePage;

export async function getServerSideProps() {
  let props = {
    pageData: "",
  };
  try {
    await API.get(
      "public/lead-contact-form/pages/study-abroad-consultants-in-chandigarh"
    ).then((resp) => {
      if (resp && resp?.data && !resp.error && resp.statusCode != 500) {
        props.pageData = resp?.data;
      }
    });
    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}
